// AUTO-GENERATED by scripts/generate-version.js. Do not edit by hand.
export default Object.freeze({
    "version": "v2026-05-21-10-48-00",
    "packageVersion": "0.1.0",
    "commit": "a511af1",
    "branch": "deploy/new-customer-install",
    "buildTime": "2026-05-21T14:53:22.566Z"
});
